import { useCallback } from 'react';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
export function useDetailQueryState(param) {
    let { queryKey, queryFn, enabled = true, refreshOnHookMount } = param;
    const { data, isLoading, error, refresh, optimisticUpdate } = useQueryState({
        queryKey,
        queryFn,
        enabled,
        refreshOnHookMount
    });
    const isNotFound = error != null && new ErrorResponse(error).hasStatus([
        404
    ]);
    const refreshWithoutThrowing = useCallback(()=>{
        void refresh({
            throwOnError: false
        });
    }, [
        refresh
    ]);
    return {
        data,
        isLoading,
        isError: error != null && !isNotFound,
        isNotFound,
        refresh: refreshWithoutThrowing,
        optimisticUpdate
    };
}
